import React, { Component } from "react";
import { Jumbotron } from "react-bootstrap";
import intl from "react-intl-universal";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import {
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
} from "react-bootstrap";
import LoaderButton from "./LoaderButton";
import "./signUp.css";
import DivsPattern from "./skylineDesignPattern";
import Industry from "./industry";

class SignUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isSignUpFailed: false,
      failedMessage: "",
      firstName: "",
      lastName: "",
      companyName: "",
      email: "",
      password: "",
      confirmPassword: "",
      newUser: false,
      showModal: true,
      industry: intl.get("Select_Industry"),
      recaptchSucceeded: true,
      confirmPasswordDisabled:true,
    };

    this._reCaptchaRef = React.createRef();
  }

  handleRecaptchChange = (value) => {
    this.setState({ recaptchSucceeded: true });
  };

  asyncScriptOnLoad = () => {
    this.setState({ callback: "called!" });
  };

  validateForm() {
    return (
      this.state.email.length > 0 &&
      this.state.password.length > 0 &&
      this.state.confirmPassword.length > 0 &&
      this.state.firstName.length > 0 &&
      this.state.lastName.length > 0 &&
      this.state.companyName.length > 0 &&
      this.state.industry !== intl.get("Select_Industry") &&
      this.state.recaptchSucceeded
    );
  }

  industryHasChanged = (event) => {
    this.setState({ industry: event.target.value });
  };

  handleChange  = event => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  handlePassword = (event) =>{
    var mediumRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    if (!mediumRegex.test(event.target.value)){
      this.setState({ confirmPasswordDisabled:true, isSignUpFailed:true, [event.target.id]: event.target.value, failedMessage: intl.get("Password_Illegal") });
    }
    else{
      this.setState({isSignUpFailed:false,
        [event.target.id]: event.target.value,
        confirmPasswordDisabled:false
      });
    }
   
  }

  handleSubmit = (event) => {
    event.preventDefault();
    if (!this.validateForm()) {
      this.setState({
        failedMessage: intl.get("Mandatory_Fields_Error"),
      });
      this.setState({ isSignUpFailed: true });
      return;
    }

    if (!this.validateEmail(this.state.email)){
      this.setState({ failedMessage: intl.get("Email_Illegal") , isSignUpFailed: true});
      return;
    }

    if (this.state.password !== this.state.confirmPassword) {
      this.setState({ failedMessage: intl.get("Password_Not_Match") });
      this.setState({ isSignUpFailed: true });
      return;
    }

    this.setState({ isLoading: true });

    fetch(process.env.REACT_APP_API_URL + "signup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        FirstName: this.state.firstName,
        LastName: this.state.lastName,
        Email: this.state.email,
        Password: this.state.password,
        Industry: this.state.industry,
        CompanyName: this.state.companyName,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.Result.toString().toLowerCase() == "success") {
          this.setState({ isSignUpFailed: false });
          this.setState({ newUser: true });
          this.setState({ isLoading: false });
        } else {
          this.setState({ isSignUpFailed: true });
          if (
            result.Result &&
            result.Result.toString().toLowerCase() === "validation"
          ) {
            switch (result.Validations[0].ValidationCode.toString()) {
              case "FieldEmpty":
                this.setState({ failedMessage: intl.get("Field_Empty") });
                break;
              case "EmailIllegal":
                this.setState({ failedMessage: intl.get("Email_Illegal") });
                break;
              case "EmailExists":
                this.setState({ failedMessage: intl.get("Email_Exists") });
                break;
              case "PasswordIllegal":
                this.setState({ failedMessage: intl.get("Password_Illegal") });
                break;
              case "NameIllegal":
                this.setState({ failedMessage: intl.get("Name_Illegal") });
                break;
              case "LastNameIllegal":
                this.setState({ failedMessage: intl.get("Last_Name_Illegal") });
                break;
              default:
                this.setState({ failedMessage: intl.get("General_Failure") });
                break;
            }
          } else this.setState({ failedMessage: result.ErrorMessage });
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        console.error(error);
        this.props.handleServerError(true);
      });

    //this.setState({ newUser: "test" });
    //this.setState({ isLoading: false });
  };

  validateEmail = (email) =>{
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const regex = new RegExp(re);
    if(regex.test(String(email).toLowerCase())){
      return true;
    }
    return false;
  };

  handleResendSubmit = (event) => {
    event.preventDefault();

    this.setState({ isLoading: true });

    fetch(process.env.REACT_APP_API_URL + "ResendSignupEmail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Email: this.state.email,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.Result == "Success") {
        } else {
          if (result.Result && result.Result === "Validation") {
            switch (result.Validations[0].ValidationCode.toString()) {
              case "FieldEmpty":
                this.setState({ failedMessage: intl.get("Field_Empty") });
                break;
              case "EmailIllegal":
                this.setState({ failedMessage: intl.get("Email_Illegal") });
                break;
              case "EmailExists":
                this.setState({ failedMessage: intl.get("Email_Exists") });
                break;
              case "PasswordIllegal":
                this.setState({ failedMessage: intl.get("Password_Illegal") });
                break;
              case "NameIllegal":
                this.setState({ failedMessage: intl.get("Name_Illegal") });
                break;
              case "LastNameIllegal":
                this.setState({ failedMessage: intl.get("Last_Name_Illegal") });
                break;
              default:
                this.setState({ failedMessage: intl.get("General_Failure") });
                break;
            }
          } else if (result.ErrorMessage.toString() !== "")
            this.setState({ failedMessage: result.ErrorMessage });
        }
        this.setState({ isLoading: false });
      })
      .catch((error) => {
        console.error(error);
        this.props.handleServerError(true);
      });
  };

  renderForm() {
    return (
      <DivsPattern>
        <form className="form-signin" onSubmit={this.handleSubmit}>
          <FormGroup controlId="firstName" className="form-label-group">
            <FormControl
              autoFocus
              value={this.state.firstName}
              onChange={this.handleChange}
              placeholder={intl.get("First_Name") + " *"}
              className="form-control"
              required
            />
          </FormGroup>
          <FormGroup controlId="lastName" className="form-label-group">
            <FormControl
              value={this.state.lastName}
              onChange={this.handleChange}
              placeholder={intl.get("Last_Name") + " *"}
              className="form-control"
              required
            />
          </FormGroup>
          <FormGroup controlId="email" className="form-label-group">
            <FormControl
              type="email"
              value={this.state.email}
              placeholder={intl.get("Eamil_Address_Test") + " *"}
              onChange={this.handleChange}
              className="form-control"
              required
            />
          </FormGroup>
          <FormGroup controlId="password" className="form-label-group">
            <FormControl
              value={this.state.password}
              onChange={this.handlePassword}
              type="password"
              placeholder={intl.get("Password_Test") + " *"}
              className="form-control"
              required
            />
          </FormGroup>
          <FormGroup controlId="confirmPassword" className="form-label-group">
            <FormControl
              value={this.state.confirmPassword}
              onChange={this.handleChange}
              type="password"
              placeholder={intl.get("Confirm_Password_Text") + " *"}
              className="form-control"
              disabled = {this.state.confirmPasswordDisabled}
              required
            />
          </FormGroup>
          <FormGroup controlId="companyName" className="form-label-group">
            <FormControl
              value={this.state.companyName}
              onChange={this.handleChange}
              placeholder={intl.get("Company_Name") + " *"}
              className="form-control"
              required
            />
          </FormGroup>
          <Industry onChange={this.industryHasChanged} />
          <ReCAPTCHA
            className="form-label-group"
            style={{ textAlign: "-webkit-center" }}
            ref={this._reCaptchaRef}
            sitekey={"6LeGzZsUAAAAALreua0d6EHa5KYeao1aaE1QCGup"}
            onChange={this.handleRecaptchChange}
            asyncScriptOnLoad={this.asyncScriptOnLoad}
          />
          
          <LoaderButton
            block
            className="btn btn-lg btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2"
            // disabled={!this.validateForm()}
            type="submit"
            isLoading={this.state.isLoading}
            text={intl.get("Sign_Up")}
            loadingText={intl.get("Signing_Out")}
          />
          {this.state.isSignUpFailed ? (
            <div id="divError">
              <span style={{ color: "red" }}>{this.state.failedMessage}</span>
            </div>
          ) : null}
        </form>
        <p>
          {intl.get("Sign_Up_Already_Have_An_Account_Question")}{" "}
          <Link to="/signIn">{intl.get("LogIn_Text")}</Link>
        </p>
      </DivsPattern>
    );
  }

  renderConfirmationForm() {
    return (
      <DivsPattern headerText={intl.get("Sign_Up_Confirmation_Title")}>
        <div className="form-label-group">
          <p>
            {intl.get("Sign_Up_Confirmation_Text", { email: this.state.email })}
          </p>
          <br />
          <p>{intl.get("Sign_Up_Confirmation_Resend_Text")}</p>
          <div className="text-center">
            <LoaderButton
              className="small ResendButton"
              text={intl.get("Sign_Up_Confirmation_Resend_Button_Text")}
              href="#"
              isLoading={this.state.isLoading}
              onClick={this.handleResendSubmit}
              loadingText={intl.get("Resending_An_Email")}
            />
          </div>
        </div>
      </DivsPattern>
      // <Jumbotron bsClass="container">
      //   <h1>{intl.get("Sign_Up_Confirmation_Title")}</h1>
      //   <p>
      //     {intl.get("Sign_Up_Confirmation_Text", { email: this.state.email })}
      //   </p>
      //   <br />
      //   <p>{intl.get("Sign_Up_Confirmation_Resend_Text")}</p>
      //   <button
      //     className="btn btn-lg btn-primary btn-block btn-signin"
      //     type="button"
      //     onClick={this.handleSubmit}
      //   >
      //     {intl.get("Sign_Up_Confirmation_Resend_Button_Text")}
      //   </button>
      // </Jumbotron>
    );
  }

  render() {
    return (
      <div>
        {!this.state.newUser
          ? this.renderForm()
          : this.renderConfirmationForm()}
      </div>
    );
  }
}

export default SignUp;
